import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map'
import { AppState } from '../../app.service';
import { HttpClient, HttpParams } from "@angular/common/http";
import { TokenResponse } from "./TokenResponse";
import { Observable } from "rxjs/Observable";

@Injectable()
export class AuthenticationService {

    private static getsecuretokenUrl: string = '/api/getsecuretoken';
    private static verifyusernameUrl: string = '/api/account/verifyusername/';
    private static getuserinfoUrl: string = '/api/account/getuserinfo';
    private static getallUrl: string = '/api/country/getall';
    private static imageUrl: string = 'https://bricksandall.blob.core.windows.net/avatar/profile.jpg';

    constructor(
        private http: HttpClient,
        public appState: AppState
    ) { }

    public login(username: string, password: string): Observable<TokenResponse> {
        const body = new HttpParams()
            .set('grant_type', 'password')
            .set('username', username)
            .set('password', password)
            .set('programshortcode', process.env.program);
        const options = {
            withCredentials: false
        };
        return this.http.post<TokenResponse>(AuthenticationService.getsecuretokenUrl, body, options);
    }

    public checkAvailability(username: string): Observable<any> {
        return this.http.get<any>(AuthenticationService.verifyusernameUrl + username);
    }

    public setUserInfoCookie(): void {
        this.http.get<any>(AuthenticationService.getuserinfoUrl)
            .subscribe(data => {
                this.appState.setCookie("userIdentity", JSON.stringify(data));
                this.appState.setCookie("imageUrl", data.ImageUrl || AuthenticationService.imageUrl);
            });
    }

    public getAvailableCountries(): Observable<Promise<any>> {
        return this.http.get<any>(AuthenticationService.getallUrl);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/services/SecurityServices/authentication.service.ts